var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "room-exam-component justify-center items-center absolute inset-0 lg:grid",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "room-exam w-full h-full rounded bg-white p-3 pt-12 flex flex-col gap-y-3 relative overflow-hidden lg:w-960 lg:h-4/5 lg:p-10 lg:pt-16 lg:gap-y-5",
          class: {
            "pb-0": _vm.view === "testbank__exam",
          },
        },
        [
          _c("GrmTabs", {
            staticClass: "absolute top-0 right-0 left-0",
            attrs: { value: _vm.testbankTab, tabs: _vm.testbankTabs },
            on: {
              "update:value": function ($event) {
                _vm.testbankTab = $event
              },
            },
          }),
          _c(
            "div",
            { staticClass: "flex justify-between items-center" },
            [
              _c("span", { staticClass: "text-lg font-bold" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "min-h-0 flex-1 -mx-3 px-3 overflow-y-auto lg:-mx-10 lg:px-10",
              attrs: { id: "roomExamContentComponentWrapper" },
            },
            [
              _c(
                "div",
                { staticClass: "h-full flex flex-col relative" },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade" } },
                    [
                      _c(_vm.roomExamContentComponent, {
                        tag: "component",
                        staticClass: "absolute inset-0",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.view === "testbank__exam" && _vm.testbankExam.bankExamId
                ? _c("TestbankInfoFooter")
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }